// extracted by mini-css-extract-plugin
export default {"event":"Calendar_event__AR2qi","loading":"Calendar_loading__Xidtr"};